// Archivo: src/pages/ForgotPasswordPage.js

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../services/auth.Service';

// --- Componente de Logo (Reutilizado) ---
const AppLogo = () => (
    <div className="text-center mb-8">
        <div className="inline-block bg-gob-azul-medio p-4 rounded-full shadow-lg">
            <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
        </div>
    </div>
);


const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setMessage('');
            try {
                const frontendUrl = `${window.location.origin}/reset-password`;
                const response = await forgotPassword({ email, url: frontendUrl });
                setMessage(response.message || 'Se envió el enlace si el usuario existe.');
            } catch (err) {
            setError(err.message || 'Ocurrió un error inesperado.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-gob-fondo min-h-screen flex flex-col justify-center items-center p-4 font-sans">
            <main className="w-full max-w-md animate-fade-in-up">
                <div className="bg-white p-10 rounded-2xl shadow-2xl border border-gray-100">
                    <AppLogo />
                    <header className="text-center mb-8">
                        <h1 className="text-4xl font-extrabold text-gob-azul-oscuro tracking-tight">Restablecer Contraseña</h1>
                        <p className="text-gray-500 mt-2">
                            Ingresa tu email y te enviaremos las instrucciones.
                        </p>
                    </header>
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 sr-only" htmlFor="email">
                                Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Escribe tu correo electrónico"
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-gob-azul-medio sm:text-sm transition-shadow"
                                required
                            />
                        </div>

                        {message && <p className="text-green-600 text-sm text-center font-semibold bg-green-50 p-3 rounded-lg">{message}</p>}
                        {error && <p className="text-red-600 text-sm text-center font-semibold bg-red-50 p-3 rounded-lg">{error}</p>}

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-gob-azul-medio hover:bg-gob-azul-oscuro text-white font-bold py-3 px-4 rounded-lg transition-all duration-300 disabled:bg-blue-300 transform hover:scale-105 shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gob-azul-medio"
                        >
                            {loading ? 'Enviando...' : 'Enviar Enlace'}
                        </button>
                    </form>
                    <div className="text-center mt-6">
                        <Link to="/login" className="text-sm text-gob-azul-medio hover:underline font-medium">
                            &larr; Volver al inicio de sesión
                        </Link>
                    </div>
                </div>
            </main>
            <footer className="text-center mt-8 text-sm text-gray-400">
                <p>&copy; {new Date().getFullYear()} Gobierno de Salta. Todos los derechos reservados.</p>
            </footer>
        </div>
    );
};

export default ForgotPasswordPage;
